import React from 'react';

const TONE = { updated: 'text-[#00E676]', already_updated: 'text-[#00E5FF]', skipped: 'text-[#FF9100]' };

export function SheetSyncResult({ result }) {
  const u = result.email_updates;
  const l = result.merchant_list;
  return (
    <div className="space-y-3" data-testid="sheet-sync-result">
      <p className="text-sm">
        {result.dry_run && <span className="text-[#FFEA00] font-semibold mr-2">PREVIEW (nothing changed)</span>}
        <span data-testid="sheet-sync-summary">
          {u.updated} email(s) {result.dry_run ? 'would be ' : ''}updated · {l.rows_updated} list rows refreshed · {l.rows_added} rows added ({l.merchants} merchants)
        </span>
      </p>
      {u.rows.length > 0 && (
        <div className="max-h-60 overflow-y-auto rounded-md border border-white/10">
          <table className="w-full text-xs">
            <thead className="bg-[#000B18] text-[#5C7599] uppercase text-[10px]">
              <tr><th className="text-left p-2">Row</th><th className="text-left p-2">Merchant</th><th className="text-left p-2">Updated email</th><th className="text-left p-2">Result</th></tr>
            </thead>
            <tbody>
              {u.rows.map((r) => (
                <tr key={r.row} className="border-t border-white/5" data-testid={`sheet-sync-row-${r.row}`}>
                  <td className="p-2 text-[#5C7599]">{r.row}</td>
                  <td className="p-2">{r.business_name || '—'}<div className="text-[#5C7599]">{r.old_db_email || r.email}</div></td>
                  <td className="p-2">{r.updated_email || '—'}</td>
                  <td className={`p-2 ${TONE[r.result] || ''}`}>
                    {r.result.replace(/_/g, ' ')}{r.reason ? `: ${r.reason}` : ''}{r.invitation_requeued ? ' · invitation re-queued' : ''}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
